module.exports = __webpack_public_path__ + "img/98.59cb0e27.webp";